import styled from 'styled-components';

export const HelpElement = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: gainsboro;
`;
